import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-dotted-arrow-left",
  "use": "icon-s-dotted-arrow-left-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-dotted-arrow-left\"><path d=\"M12.434 9.837v2h-8.03l6.274 6.274-1.323 1.323L2.08 12.16.759 10.837l8.596-8.596 1.323 1.323-6.274 6.273zm-9 .97-.03.03.03.03zm11-.97h2v2h-2zm4 0h2v2h-2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol